// 空态组件：显示标题 + 描述 + 可选 action / 文档链接，引导用户下一步。

import type { ReactNode } from "react";

interface EmptyProps {
  title: string;
  description?: ReactNode;
  action?: ReactNode;
  doc?: { href: string; label: string };
}

export function Empty({ title, description, action, doc }: EmptyProps) {
  return (
    <div className="rounded border border-dashed border-[hsl(var(--border))] px-6 py-10 text-sm text-[hsl(var(--muted-foreground))]">
      <div className="text-base font-medium text-[hsl(var(--foreground))]">{title}</div>
      {description ? <div className="mt-2">{description}</div> : null}
      {(action || doc) && (
        <div className="mt-4 flex items-center gap-3">
          {action}
          {doc ? (
            <a className="underline" href={doc.href} target="_blank" rel="noreferrer">
              {doc.label}
            </a>
          ) : null}
        </div>
      )}
    </div>
  );
}
